import { render, staticRenderFns } from "./SupportTracker.vue?vue&type=template&id=01bf3543"
import script from "./SupportTracker.vue?vue&type=script&lang=js"
export * from "./SupportTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports